import { DropdownItem } from "../types";

export const booleanDropdownOptions = [
  {
    value: "true",
    label: "Tak",
  },
  {
    value: "false",
    label: "Nie",
  },
] satisfies DropdownItem<string>[];

export const resolveBooleanOption = (
  option: string | undefined,
): boolean | undefined => {
  if (option === undefined) {
    return undefined;
  }
  return option === "true";
};
